export default "__VITE_ASSET__BlJA2PpH__"